import { Link } from "react-router-dom";
import { categories, contactEmail, siteName } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-secondary-950 text-background-100">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-10 px-4 py-14 md:px-6 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">{siteName}</span>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-background-300">
            专注圈内秘闻与深扒，爆料、内幕、猛料、起底都有。不追热点的表面稿，直接给你事件背后的脉络和证据链。
          </p>
          <p className="mt-6 flex items-center gap-2 text-sm text-background-300">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-mail-line text-secondary-300"></i>
            </span>
            线索投稿：{contactEmail}
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
            <a href="/#latest" className="cursor-pointer hover:text-accent-400">内容分类</a>
          </h4>
          <ul className="mt-4 space-y-3">
            {categories.map((item) => (
              <li key={item.slug}>
                <Link
                  to={`/?cat=${item.slug}#latest`}
                  className="cursor-pointer text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
            <a href="/#deepdive" className="cursor-pointer hover:text-accent-400">站内导航</a>
          </h4>
          <ul className="mt-4 space-y-3 text-sm text-background-300">
            <li>
              <a href="/#deepdive" className="cursor-pointer transition-colors hover:text-accent-400">深扒专题</a>
            </li>
            <li>
              <a href="/#ranking" className="cursor-pointer transition-colors hover:text-accent-400">爆料热榜</a>
            </li>
            <li>
              <a href="/#faq" className="cursor-pointer transition-colors hover:text-accent-400">常见问题</a>
            </li>
            <li>
              <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-400">关于我们</Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
            <a href="/#subscribe" className="cursor-pointer hover:text-accent-400">关注我们</a>
          </h4>
          <ul className="mt-4 space-y-3 text-sm text-background-300">
            <li>
              <a href="/#subscribe" className="cursor-pointer transition-colors hover:text-accent-400">每周深扒推送</a>
            </li>
            <li>
              <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-400">内容原则</Link>
            </li>
            <li>
              <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-400">投稿方式</Link>
            </li>
            <li>
              <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-400">联系我们</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="mx-auto flex max-w-content flex-col items-center justify-between gap-4 px-4 py-6 text-xs text-background-400 sm:flex-row md:px-6">
          <p>© 2026 {siteName} · 内容为公开信息整理与行业观察，人物均作匿名处理</p>
          <p className="flex items-center gap-2">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-shield-check-line text-secondary-300"></i>
            </span>
            理性吃瓜 · 不信谣不传谣
          </p>
        </div>
      </div>
    </footer>
  );
}